<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row class="mb-2">
          <!-- Options de validation -->
          <b-col xl="2" md="4" sm="6">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left">Nbr page</label>
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="" />
            </b-form-group>
          </b-col>

          <b-col xl="2" md="4" sm="6">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left">Année</label>
              <b-form-select id="yearSelect" v-model="currentYear" size="sm" :options="yearOptions"
                class="" />
            </b-form-group>
          </b-col>

          <b-col xl="4" sm="12">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left">Statut</label>
              <v-select v-model="selectedStatus" multiple label="title" :options="optionStatus"
                :reduce="option => option.value" />
            </b-form-group>
          </b-col>

          <b-col xl="4" sm="12">
            <b-form-group label-for="filterInput" class="mb-0">
              <label class="d-inline-block text-sm-left">Filtrer</label>
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Rechercher..." @input="fetchUserObjectives"/>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''; fetchUserObjectives()">Effacer</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="align-items-center mb-2">
          <b-col cols="12" md="4" class="mb-1 mb-md-0">
            <label>Direction</label>
            <v-select
                v-model="selectedDirections"
                :options="directionOptions"
                label="name"
                placeholder="Toutes les directions"
                class="filter-selector"

            />
          </b-col>

          <b-col cols="12" md="4" class="mb-1 mb-md-0">
            <label>Service</label>
            <v-select
                v-model="selectedServices"
                :options="serviceOptions"
                label="name"
                placeholder="Tous les services"
                class="filter-selector"
            />
          </b-col>

          <b-col class="mb-1 mb-md-0">
            <label>Péage</label>
            <v-select
                v-model="selectedToll"
                :options="tollOptions"
                label="name"
                placeholder="Tous les péage"
                class="filter-selector"
            />
          </b-col>

          <b-col cols="auto" class="d-flex justify-content-end align-items-end mt-1">
            <b-button variant="primary" @click="exportUserObjectives">
              Exporter
            </b-button>
          </b-col>
        </b-row>

        <!-- :per-page="perPage" :current-page="currentPage"  :filter="filter" :filter-included-fields="filterOn" -->
        <b-row>
          <b-col cols="12">
            <b-table striped hover responsive  :items="userObjectives"
              :fields="tableColumns" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
             @filtered="onFiltered">
              <template #cell(user)="data">
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar size="40" variant="light-primary" class="badge-minimal" badge-variant="success">
                      {{ getUserInitials(data.item.users) }}
                    </b-avatar>
                  </template>
                  <span class="font-weight-bold d-block text-nowrap">{{ data.item.users.lastName + ' ' +
                    data.item.users.firstName
                    }}</span>
                  <small class="text-muted">{{ data.item.users.mail }}</small>
                </b-media>
              </template>
              <template #cell(fonction)="data">
                <span class="font-weight-bold d-block text-nowrap">{{ data.item.users.fonction }}</span>

                <small class="text-muted" v-if="data.item.users.usersHierarchique">Manager : {{ data.item.users.usersHierarchique[0].fullName }}</small>
              </template>
              <template #cell(status)="data">
                <b-badge :variant="statusVariants[data.item.status]">{{ statusLabels[data.item.status] }}</b-badge>
              </template>

              <template #cell(nextStep)="data">
                <span class="text-primary">{{ nextStepLabels[data.item.status] }}</span>
              </template>

              <template #cell(actions)="data">
                <div class="text-nowrap">
                  <feather-icon :id="`objective_print-row-${data.item.id}-preview-icon`" icon="EyeIcon" size="16"
                    class="mx-1" @click="$router.push({ name: 'objectif_print', params: { id: data.item.id, isRapport: 1 } })" />
                  <b-tooltip title="Detail Objectif" :target="`objective_print-row-${data.item.id}-preview-icon`" />

                  <feather-icon :id="`${data.item.id}-preview-icon`" icon="EditIcon" size="16"
                                class="mx-1"  @click="handleClick(data.item)"/>
                  <b-tooltip title="Modifier statut" :target="`${data.item.id}-preview-icon`"/>

                  <!--                    -->

<!--                  <b-tooltip :title="tooltipTitle(data.item)" :target="iconId" />-->

                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-card-body>
      <b-col cols="12">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
          class="my-1" />
          <p>Total: {{ totalRows }} | Par page: {{ perPage }}</p>

      </b-col>
    </b-card>
    <b-modal
        id="objective-back-modal"
        title="Retour en arrière"
        ok-title="Confirmer"
        cancel-title="Annuler"
        :ok-disabled="!selectedStatusUpdate"
        v-model="isModalActive"
        @ok="handleOk"
        centered
    >
      <b-form-group label="Statut" label-for="custom-objective-back">
        <v-select v-model="selectedStatusUpdate"  label="title" :options="availableStatusUpdate"
                  :reduce="option => option.value" />
      </b-form-group>
    </b-modal>

  </div>



</template>


<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend, BModal,
  BPagination,
  BRow,
  BTable
} from 'bootstrap-vue'
import {
  getUserObjectivesAll,
  getUserObjectivesAllToExport,
  updateDateObjectiveStatus
} from '@/services/UserObjectiveService'
import vSelect from 'vue-select'
import {allYears} from '@/services/YearsService';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {getJsonFromStorage} from "@/util/storageUtils";
import {getSetting} from "@/services/SettingService"; // Importer la fonction pour récupérer les données du stockage
import {allServicesByDirections} from "@/services/ServicesService";
import {getAllDirectionsByActive} from "@/services/DirectionsService";
import {allPeagesActive} from "@/services/TollService";
import {getAllUsers} from "@/services/UserService";
import * as XLSX from "xlsx-js-style";
import moment from "moment";
export default {
  components: {
    BModal,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    vSelect,
  },
  data() {
    return {
      perPage: 10,
      pageOptions: [3, 5, 10, 25, 50, 100, 200],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      isModalActive: false,
      isEditMode : false,
      selectedServices:null,
      selectedDirections:null,
      serviceOptions:[],
      directionOptions: [],
      selectedToll: null,
      tollOptions: [],
      // tableColumns: [
      //   { key: 'user', label: 'Nom Prénom(s)', sortable: true },
      //   { key: 'fonction', label: 'Fonction', sortable: true },
      //   { key: 'services', label: 'Services', sortable: true },
      //   { key: 'status', label: 'Status', sortable: true },
      //   { key: 'actions', label: 'Actions' },
      // ],
      userObjectives: [],
      userObjectivesToExport: [],
      totalRowsToExport: 1,
      currentYear: null,
      years: [],
      // user:'',
      selectedStatus: [],
      selectedStatusUpdate:null,


      statusLabels: {
        PROPOSE: "Proposé",
        VALIDE_HIERARCHY_1: "Validé par manager N°1",
        VALIDE_HIERARCHY_2: "Validé manager N°2",
        REJETE: "Rejeté",
        VALIDE_COLLABORATEUR: "Validation finale",
        TRANSMIT_HIERARCHY_2: "Transmis manager N°2",
      },
      nextStepLabels: {
        PROPOSE: "Validation/Rejet par manager N°1 !",
        VALIDE_HIERARCHY_1: "Validation par collaborateur !",
        VALIDE_HIERARCHY_2: "Validation par collaborateur !",
        REJETE: "Correction des objectifs !",
        VALIDE_COLLABORATEUR: "-",
        TRANSMIT_HIERARCHY_2: "Validation par manager N+2 !",
      },
      optionStatus: [
        { value: 'PROPOSE', title: 'Proposé' },
        { value: 'VALIDE_HIERARCHY_1', title: 'Validé par manager N°1' },
        { value: 'VALIDE_HIERARCHY_2', title: 'Validé manager N°2' },
        { value: 'REJETE', title: 'Rejeté' },
        { value: 'VALIDE_COLLABORATEUR', title: 'Validation finale' },
        { value: 'TRANSMIT_HIERARCHY_2', title: 'Transmis manager N°2' },
      ],
      optionStatusUpdate: [
        { value: 'PROPOSE', title: 'Proposé' },
        { value: 'VALIDE_HIERARCHY_1', title: 'Validé par manager N°1' },
        { value: 'TRANSMIT_HIERARCHY_2', title: 'Transmis manager N°2' },
        { value: 'VALIDE_HIERARCHY_2', title: 'Validé manager N°2' },
        { value: 'VALIDE_COLLABORATEUR', title: 'Validation finale' },
        // { value: 'REJETE', title: 'Rejeté' },
      ],

      statusVariants: {
        PROPOSE: "primary",
        VALIDE_HIERARCHY_1: "success",
        VALIDE_HIERARCHY_2: "success",
        REJETE: "danger",
        VALIDE_COLLABORATEUR: "success",
        TRANSMIT_HIERARCHY_2: "warning",
      },
      userObjectivesDate:{},
      userData:null,
      currentObjectif: null,
    }
  },
  computed: {
     yearOptions() {
    return this.years.map(y => ({
      value: y.year,
      text: y.year.toString()
    })); },
    availableStatusUpdate() {
      if (!this.currentObjectif) return []
      const { status, rejetHierachyn, signatureObjective } = this.currentObjectif

      if (status === 'REJETE') {
        if (rejetHierachyn=== 1) {
          return this.optionStatusUpdate.filter(s => s.value === 'PROPOSE')
        }
        else if (rejetHierachyn === 2) {
          return this.optionStatusUpdate.filter(
              s => !['VALIDE_HIERARCHY_2', 'VALIDE_COLLABORATEUR'].includes(s.value)
          )
        }
        return this.optionStatusUpdate.filter(s => s.value === 'PROPOSE')
      }
      const signatures = signatureObjective || []
      let statuses = [...this.optionStatusUpdate]

      if (status === 'VALIDE_COLLABORATEUR' && signatures.length === 1) {
        statuses = statuses.filter(
            s => !['TRANSMIT_HIERARCHY_2', 'VALIDE_HIERARCHY_2'].includes(s.value)
        )
      }

      let currentIndex = statuses.findIndex(
          s => s.value === status
      )
      return statuses.slice(0, currentIndex)
    },

    tableColumns() {

      const columns = [
        { key: 'user', label: 'Nom Prénom(s)', sortable: true },
        { key: 'fonction', label: 'Fonction', sortable: true },
        // { key: '-', label: 'Appréciation', sortable: true },
        { key: 'status', label: 'Statut', sortable: true },
        { key: 'nextStep', label: 'Prochaine étape', sortable: true },
        { key: 'actions', label: 'Actions' },
      ]
      if (this.userObjectives.services) {
        columns.push({ key: 'services', label: 'Services', sortable: true })
      }
      return columns
    },
    sortOptions() {
      return this.tableColumns.filter(f => f.sortable).map(f => ({ text: f.label, value: f.key }))
    },
    iconId(data) {

      return `objective-row-${data.id}-preview-icon`;
    },

  },

  methods: {
    async onDirectionSelected(direction) {

      if (direction && direction.id) {
        this.serviceOptions = await allServicesByDirections(direction.id);
      } else {
        // Si aucune direction sélectionnée → pas de service filtré
        this.serviceOptions = [];
        this.selectedServices = null;
      }
    },
    async onServiceSelected(service) {

      if (service && service.id && service.toll) {
        this.tollOptions = await allPeagesActive(service.toll);
      } else {
        // Si aucune direction sélectionnée → pas de service filtré
        this.tollOptions = [];
        this.selectedToll = null;
      }
    },
    async fetchOnDirection() {
      try {
        this.directionOptions = await getAllDirectionsByActive(true);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    tooltipTitle(data) {
      return data.dateObjectifPrevu ? "Éditer Objectif" : "Définir la date de validation";
    },
     showToast (message, color, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Notification',
          icon: icon,
          timeout: 8000,
          text: message,
          variant: color,
        },
      });
    },


    getUserInitials(user) {
      const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : ''
      const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : ''
      return `${lastInitial}${firstInitial}`
    },
    async fetchUserObjectives() {
      try {
        this.userData = getJsonFromStorage('userData')
        if ( this.currentYear) {
          const response = await getUserObjectivesAll(this.currentPage - 1, this.perPage,
              null, this.selectedStatus, this.currentYear,this.filter,false,   this.selectedServices?.id,this.selectedDirections?.id,
              this.selectedToll?.id)

          if (response ) {
            this.userObjectives = response.userObjectives
            this.totalRows = response.count

          }

        }

      } catch (error) {
        console.error('Error fetching user objectives:', error)
      }
    },
    async getAllYears() {

      this.years = await allYears();
      this.currentYear = this.years[0].year


    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    handleClick(evaluation) {
      this.currentObjectif = { ...evaluation }
      this.selectedStatusUpdate = null
      this.isModalActive = true
    },
    handleOk(){


      const message = `
        <span class="small-swal-message">
          Êtes-vous sûr de vouloir modifier le statut de l'objectif ${this.currentObjectif.years} de
          <strong>${this.currentObjectif.users.fullName}</strong>
          vers : <span class="text-danger font-weight-bolder">${this.statusLabels[this.selectedStatusUpdate]}</span> ?
        </span>
      `;

      this.$swal({
        title: '<span class="small-swal-title">Vous ne pourrez pas revenir en arrière !</span>',
        html: message,
        // text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, modifier !',
        cancelButtonText: 'Annuler',
        // customClass: {
        //   popup: 'small-swal',
        //   title: 'small-swal-title',
        //   htmlContainer: 'small-swal-text',
        //   icon: 'small-swal-icon',
        //   confirmButton: 'btn btn-primary',
        //   cancelButton: 'btn btn-outline-danger ml-1',
        // },
        customClass: {
          popup: 'small-swal',
          title: 'small-swal-title',
          htmlContainer: 'small-swal-text',
          icon: 'small-swal-icon',
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.currentObjectif.status = this.selectedStatusUpdate

          updateDateObjectiveStatus(
              this.currentObjectif.id,
              this.userData.id,
              this.currentObjectif
          )
              .then(response => {

                this.userObjectives.splice(this.userObjectives.findIndex(obj => obj.id === response.id), 1, response)
                this.$swal({
                  icon: 'success',
                  title: 'Modifié !',
                  text: 'Le statut a été mis à jour.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })

              })
              .catch(error => {
                console.error('Error updating user objective:', error)
              })

        }
      })


      // updateDateObjectiveStatus(this.currentObjectif.id,this.userData.id,this.currentObjectif).then(response => {
      //
      // }).catch(error => {
      //   console.error('Error updating user objective:', error)
      // })
      // this.fetchUserObjectives();
    },
    formatDateForExcel(date) {
      if (!date) return '';

      if (Array.isArray(date)) {
        // Format du backend: [year, month, day] ou [year, month, day, hour, minute, second]
        const [year, month, day, hour = 0, minute = 0] = date;
        const formattedDay = String(day).padStart(2, '0');
        const formattedMonth = String(month).padStart(2, '0');
        const formattedYear = String(year); // Année complète (4 chiffres)
        const formattedHour = String(hour).padStart(2, '0');
        const formattedMinute = String(minute).padStart(2, '0');

        if (hour === 0 && minute === 0) {
          return `${formattedDay}-${formattedMonth}-${formattedYear}`;
        }
        return `${formattedDay}-${formattedMonth}-${formattedYear} ${formattedHour}:${formattedMinute}`;
      }

      if (typeof date === 'string') {
        // Gérer les formats: "2026-04-15", "2026-04-15 08:00:00", ou "15-04-26 08:00"
        const parts = date.split(' ');
        const datePart = parts[0];
        const timePart = parts[1];

        const dateSegments = datePart.split('-');
        let day, month, year;

        // Si le premier segment a 4 chiffres, c'est YYYY-MM-DD
        if (dateSegments[0].length === 4) {
          [year, month, day] = dateSegments;
        }
        // Si le dernier segment a 2 chiffres, c'est DD-MM-YY (année courte à corriger)
        else if (dateSegments[2].length === 2) {
          [day, month, year] = dateSegments;
          year = '20' + year; // Convertir 26 en 2026
        }
        // Sinon c'est DD-MM-YYYY
        else {
          [day, month, year] = dateSegments;
        }

        day = String(day).padStart(2, '0');
        month = String(month).padStart(2, '0');

        if (timePart) {
          const [hour, minute] = timePart.split(':');
          return `${day}-${month}-${year} ${hour}:${minute}`;
        }
        return `${day}-${month}-${year}`;
      }

      return '';
    },

    async exportUserObjectives() {

      if ( this.currentYear) {
        const response = await getUserObjectivesAllToExport(null, null,
            null, this.selectedStatus, this.currentYear,this.filter,false,   this.selectedServices?.id,this.selectedDirections?.id,
            this.selectedToll?.id)

        if (response ) {
          this.userObjectivesToExport = response.userObjectives
          this.totalRowsToExport = response.count

        }

      }

      if (!this.userObjectivesToExport || this.totalRows === 0) {
        this.showToast("Aucun objectif à exporter", "danger");
        return;
      }

      this.showToast("Exportation en cours...", "success");
      const exportData = this.userObjectivesToExport.map(u => ({
        Matricule: u.users.matricule || "",
        Civilité: u.users.civilite || "",
        Nom: u.users.lastName || "",
        Prénom: u.users.firstName || "",
        Téléphone: u.users.telephone || "",
        Email: u.users.mail || "",
        fonctionDate: u.users.fonctionDate || "",
        Fonction: u.users.fonction || "",
        Service: u.users.services?.name || "",
        Direction: u.users.directions?.name || "",
        'Poste Peage': u.toll?.name || "",
        'Manager N1': (u.users.usersHierarchique && u.users.usersHierarchique.length > 0)
            ? u.users.usersHierarchique[0].fullName
            : "-",
        'Manager N2': (u.users.usersHierarchique && u.users.usersHierarchique.length > 1)
            ? u.users.usersHierarchique[1].fullName
            : "-",
        'Date Proposition Objectif': this.formatDateForExcel(u.dateCreate) || "-",
        'Date Entretien Objectif': this.formatDateForExcel(u.dateObjectifPrevu) || "-",
        'Date Validation Manager 1': this.formatDateForExcel(u.signatureObjective?.find(sig => sig.hierarchyn === 1)?.confirmDate) || "-",
        'Validation N2 requise ?': u.signatureObjective?.find(sig => sig.hierarchyn === 2) ? "Oui" : "Non",
        'Date Validation Manager 2': this.formatDateForExcel(u.signatureObjective?.find(sig => sig.hierarchyn === 2)?.confirmDate) || "-",
        'Date Acceptation Collaborateur': this.formatDateForExcel(u.dateValid) || "-",
        Commentaire: u.description || "",
        'Commentaire Automatique': u.descriptionAutomatic || "",
      }));

      // Feuille de calcul
      const worksheet = XLSX.utils.json_to_sheet(exportData, {origin: "A2"});

      // Titre centré
      XLSX.utils.sheet_add_aoa(worksheet, [["LISTE DES OBJECTIFS - " + this.currentYear]], {origin: "A1"});

      worksheet["!merges"] = [{
        s: {r: 0, c: 0},
        e: {r: 0, c: Object.keys(exportData[0]).length - 1}
      }];

      worksheet["A1"].s = {
        font: {bold: true, sz: 16},
        alignment: {horizontal: "center", vertical: "center"}
      };

      // Style des entêtes (gris + bordure)
      const headerRow = 1;
      const totalCols = Object.keys(exportData[0]).length;

      for (let c = 0; c < totalCols; c++) {
        const cellRef = XLSX.utils.encode_cell({r: headerRow, c});

        if (worksheet[cellRef]) {
          worksheet[cellRef].s = {
            fill: {fgColor: {rgb: "D9D9D9"}},
            font: {bold: true},
            alignment: {horizontal: "center"},
            border: {
              top: {style: "thin", color: {rgb: "000000"}},
              bottom: {style: "thin", color: {rgb: "000000"}},
              left: {style: "thin", color: {rgb: "000000"}},
              right: {style: "thin", color: {rgb: "000000"}},
            }
          };
        }
      }

      // Trouver les indices des colonnes de dates
      const dateColumns = [
        'Date Proposition Objectif',
        'Date Entretien Objectif',
        'Date Validation Manager 1',
        'Date Validation Manager 2',
        'Date Acceptation Collaborateur'
      ];
      const dateColumnIndices = Object.keys(exportData[0])
        .map((key, index) => dateColumns.includes(key) ? index : -1)
        .filter(index => index !== -1);

      // Bordures pour toutes les cellules et format texte pour les dates
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let r = 2; r <= range.e.r; r++) {
        for (let c = 0; c < totalCols; c++) {
          const cellRef = XLSX.utils.encode_cell({r, c});
          if (!worksheet[cellRef]) continue;

          // Forcer le type texte pour les colonnes de dates
          if (dateColumnIndices.includes(c)) {
            worksheet[cellRef].t = 's'; // 's' = string/text
            worksheet[cellRef].z = '@'; // Format texte Excel
          }

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: {style: "thin", color: {rgb: "000000"}},
              bottom: {style: "thin", color: {rgb: "000000"}},
              left: {style: "thin", color: {rgb: "000000"}},
              right: {style: "thin", color: {rgb: "000000"}},
            }
          };
        }
      }

      // Colonnes auto-ajustées
      worksheet["!cols"] = Object.keys(exportData[0]).map(col => ({
        wch: Math.max(col.length + 5, 20)
      }));

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Objectifs " + this.currentYear);

      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const datePrefix = `${year}${month}${day}`;

      XLSX.writeFile(workbook, `${datePrefix} - Liste des Objectifs ${this.currentYear}.xlsx`);

      this.showToast("Exportation terminée !", "success");
    }
  },
  watch: {
    selectedStatus(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUserObjectives()
    },
    currentYear(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUserObjectives()
    },
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUserObjectives()
    },
    perPage(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUserObjectives()
    },
    selectedDirections(newVal, oldVal){
      this.onDirectionSelected(newVal)
      this.fetchUserObjectives()
    },
    selectedServices(newVal, oldVal){
      this.onServiceSelected(newVal)
      this.fetchUserObjectives()
    },
    selectedToll(newVal, oldVal){
      this.fetchUserObjectives()
    }
  },
  mounted() {
    this.getAllYears()
    this.fetchOnDirection()
    this.fetchUserObjectives()

    // Gilchrist ce 10/09/2025
    getSetting()
        .then((response) => {
          this.currentYear = response.yearObjective.year;
        })
        .catch((error) => {
          console.error('Error fetching settings:', error);
          this.currentYear = { year: new Date().getFullYear() }
        });
    // Fin Gilchrist

  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

</style>
<style>
:global(.swal2-popup){
  width:350px!important;
}
.small-swal-title {
  font-size: 22px !important; /* Taille plus petite */
  font-weight: 600; /* facultatif pour garder le gras */
  line-height: 1.2;
}
.small-swal-message {
  font-size: 14px !important; /* Taille plus petite */
  line-height: 1.6;
  /*font-weight: 600; facultatif pour garder le gras */
}
</style>